// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ReferralStatsItem_imageContainer__Ojqvz","image":"ReferralStatsItem_image__PG_G5"};